import { createAction } from '@reduxjs/toolkit';

import { type LicenseTypeNature } from '../../types';

export const getLicenseTypes = createAction<{
  searchValue?: string;
  licenseTypeNature?: LicenseTypeNature;
  isCreatePage?: boolean;
}>('getLicenseTypes');
export const getOgaStatuses = createAction<string | undefined>('getOgaStatuses');
